import React from 'react'
import Header from './Header';
import Footer from './Footer';
import { connect, useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { SETFINALCARTERROR } from '../redux/actionTypes';
import { getFinalCart, converDate } from '../redux/actions/cart';
import { allOrdersTotalSelector, allOrdersCount, orderStatus } from '../redux/reducers/cart';
import { formatPrice, itemNameWithAddons } from '../common/Functions';
import socketIOClient from "socket.io-client";
const ENDPOINT = "https://www.werafoods.com:9005";


function Finalcart({ getFinalCart, orders, totalAll, orderCount, state, error }) {
    const dispatch = useDispatch();

    const getTags = (item) => {
        console.log(item, "itemitem");
        const dishtag = item.dish ? item.dish[0] : "";
        let dishClass = "";
        if (dishtag == 1) {
            dishClass = "veg";
        }

        if (dishtag == 2) {
            dishClass = "non-veg";
        }

        if (dishtag == 24) {
            dishClass = "egg";
        }
        return dishClass;
    }


    useEffect(() => {
        const orderIds = orders.map(order => order.order_id.toString());
        if (orderIds.length > 0) {
            const socket = socketIOClient(ENDPOINT);
            socket.on("notification", data => {
                if (orderIds.includes(data.message))
                    getFinalCart();
            });

            return () => {
                socket.disconnect();
            }
        }

    }, [orders])


    useEffect(() => {

        dispatch({ type: SETFINALCARTERROR, payload: "" })
        getFinalCart();
    }, [])


    return (
        <>
            <Header orderCount={orderCount} />
            <div className="placed-orders-main" style={{ marginTop: "52px" }}>
                <div className="placed-order-list">
                    {orders && orders.length > 0 && orders.map(order => <div className="placed-order" key={order.order_id}>
                        <p className="order-sucess-text">{orderStatus(order.status)}</p>
                        <div className="placed-order-head">
                            <span className="order-number font-bold">Order no {order.order_id}</span>
                            <span className="time">{converDate(order.order_date_time)}</span>
                        </div>
                        <div className="order-info">
                            {order.order_items.map((item, index) => <div className="item-info border-bottom" key={index}>
                                <div className="item-name-type">
                                    <span className={"food-type " + (getTags(item))}></span>
                                    <p className="item-name">{itemNameWithAddons(item)}</p>
                                </div>
                                <div className="quantity">
                                    <span>{item.item_quantity}</span>
                                </div>
                                <div className="item-price">
                                    <span className="font-bold">{formatPrice(item.subtotal)}</span>
                                </div>
                            </div>)}
                            <div className="order-calculations">
                                <div className="order-calculation-top">
                                    <div className="row">
                                        <div className="left"><span>Item Total</span></div>
                                        <div className="right text-right"><span>{formatPrice(order.net_amount)}</span></div>
                                    </div>
                                    {order.discount != 0 && <div className="row">
                                        <div className="left"><span>Discount</span></div>
                                        <div className="right text-right"><span>{formatPrice(order.discount)}</span></div>
                                    </div>}
                                    {order.taxes && order.taxes.map((tax, index) => <div className="row" key={index}>
                                        <div className="left">{tax.type}</div>
                                        <div className="right text-right">{formatPrice(tax.amount)}</div>
                                    </div>)}
                                </div>
                                <div className="row order-calculation-bottom">
                                    <div className="left"><span className="font-semibold">Total</span></div>
                                    <div className="right text-right"><span className="font-semibold">{formatPrice(order.gross_amount)}</span></div>
                                </div>
                            </div>
                            {/*<div className="repeat-order text-center">
                                <a className="repeat-order-link text-white font-bold" href="">Repeat Order</a>
    </div>*/}
                        </div>
                    </div>)}
                    {error && <div className="alert alert-danger">
                        {error}
                    </div>}
                </div>

            </div>
            {orders && orders.length > 0 && <Footer totalAll={totalAll} />}


        </>

    )
}

const mapStateToProps = (state) => ({
    orders: state.cart.finalCartResponse?.orders,
    totalAll: allOrdersTotalSelector(state),
    orderCount: allOrdersCount(state),
    error: state.cart.finalCartError,
    state: state
})

export default connect(mapStateToProps, { getFinalCart })(Finalcart)
